import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from 'js/util/router'
import 'babel-polyfill'
import 'js/lib/base64-polyfill'
import 'less/index.less'
// RSA加密
import JsEncrypt from 'js/lib/jsencrypt.min'
// ********************elementui*************************
import {
  Input,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Select,
  Option,
  DatePicker,
  Tooltip,
  Loading,
  Checkbox,
  Progress,
  Dialog,
  RadioGroup,
  Radio,
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import ElementLocale from 'element-ui/lib/locale'
// ********************elementui*************************

// ****************** 兼容ie placeholder*********************
import 'js/directive/directivePlaceholder'
// *******************列表拖动************************
import 'js/directive/directiveListHeadDrag'

// ******** 多语言 **************************
import VueI18n from 'vue-i18n'
import en from 'i18n/lang_en'
import zh from 'i18n/lang_zh'
import {
  getLanguage, isClient, setLanguage, resolveMultiDomain, urlParse, findOtherdomain,
} from 'util/util.js'
import store from 'store'
import maskComponent from './components/common/mask/index'
import cusConfirm from './components/common/confirm/index'
import cusToast from './components/common/toast/index'
import cusWebTool from './components/business/webtool/install'

if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true
} else {
  Vue.config.devtools = false
  Vue.config.productionTip = false
}

Vue.use(VueRouter)
Vue.use(Input)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(VueI18n)
Vue.use(Loading)
Vue.use(Tooltip)
Vue.use(Checkbox)
Vue.use(Progress)
Vue.use(Dialog)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.prototype.$jsEncrypt = new JsEncrypt()
const i18n = new VueI18n({
  locale: getLanguage(),
  // 当指定fallbackLocale时，messages使用zh做初始化
  fallbackLocale: 'zh',
  messages: {
    en: Object.assign(en, enLocale),
    zh: Object.assign(zh, zhLocale),
  },
  silentTranslationWarn: true,
})
window.i18n = i18n
ElementLocale.i18n((key, value) => i18n.t(key, value))

//* *********register cunstom components 不要调整顺序************** */
window.i18n = i18n
Vue.use(cusToast)
Vue.use(cusConfirm)
Vue.use(maskComponent)
Vue.use(cusWebTool, {
  i18n,
})

const h = new Vue().$createElement

const { _render } = Vue.prototype

// eslint-disable-next-line no-underscore-dangle
Vue.prototype._render = function renderX(...args) {
  try {
    return _render.apply(this, args)
  } catch (e) {
    console.error('Error when render called : ', e)
    return h()
  }
}

const router = new VueRouter({
  mode: 'history',
  fallback: false, // 兼容ie9强制采用history模式
  routes,
  base: '/v/', // 打包时候用
})
window.Router = router

// 用来记录所有path_type下根目录的neid
window.$HistoryMeta = {}

/* eslint-disable */
// 导航守卫
router.beforeEach((to, from, next) => {

    // //修改语言
    let language = getLanguage()
    //验证语言是否为en,zh,中的一个,如果没有则设置为zh
    const fromLanguage = ['en', 'zh'].indexOf(to.query.language)!=-1? to.query.language : (language?language:'zh')
    if(language!=fromLanguage){     //重新设置cookie中的语言
        setLanguage(fromLanguage)
        //重新加载语言
        i18n.locale = fromLanguage
    }
    next()
})

import Main from './components/main/main.vue'

window.store = store
window.version = '5.2.0.1'
// ===============================================================
let url = resolveMultiDomain(document.location.href);
let urlObject = urlParse(url);
let hostName = urlObject.hostname;
let regDomain = findOtherdomain(hostName)? /((\w|\d|-)+\.(\w|\d|-)+\.(com|net|org|gov)\.cn)(:\d*)?$/ : /((\w|\d|-)+\.(\w|\d|-)+\.\w+)(:\d*)?$/;
try {
    window.SERVER_NAME = `.${regDomain.exec(hostName)[0]}`;
}catch(e) {
    window.SERVER_NAME = `.${hostName}`;
}
// 启动app
window.document.onreadystatechange = function () {
    if (document.readyState === 'complete') {
        window.app = new Vue({
            el: '#app',
            store,
            i18n,
            render: h => h(Main),
            router: router,
        })
    }
}
window.onerror = function (message, url, line, column, error) {
    if (isClient()) {
        console.log('log---onerror::::', message, url, line, column, error);
    }
}
// **************sentry for vue **************************
// import Raven from 'raven-js'
// import RavenVue from 'raven-js/plugins/vue'
// try {
//     // 开发环境读取不到env
//     if (process.env.NODE_ENV && process.env.NODE_ENV === 'production') {
//         Raven
//             .config('//e92f029ca0e2446f88fc757872b364f6@sentry.lenovows.com/2', {
//                 environment: process.env.NODE_ENV,
//                 debug: process.env.NODE_ENV,
//             })
//             .install()
//         Raven.addPlugin(RavenVue, Vue)
//     }
// } catch (e) {
//     console.warn('sentry 加载失败!')
// }
// **************sentry for vue **************************
